"use client";

import { Turnstile } from "@marsidev/react-turnstile";
import { isEmpty } from "lodash";
import { FC, useState } from "react";

import { AnimatePhotoPortal } from "@/portals";
import { CustomizeSettingsPortal } from "@/portals";
import { useUndressContext } from "@/providers";
import { cn } from "@/utils/cn";

import { BrushSize } from "../user-flow/controls/BrushSize";
import { PromtArea } from "../user-flow/controls/PromtArea";
import { RenderButton } from "../user-flow/controls/RenderButton";

export const Controls: FC = () => {
  const { undressings, clickUndressingFile } = useUndressContext();

  const [token, setToken] = useState<string | null>(null); // Токен капчи для гостей

  if (isEmpty(undressings) && !clickUndressingFile) {
    return null;
  }

  return (
    <div className={cn("w-full", "md:rounded-xl md:bg-card md:p-3")}>
      <div className={cn("w-full", "md:m-auto md:max-w-110")}>
        {/**
         * Turnstile - капча Cloudflare для гостей.
         * Отображается скрыто, сохраняем токен при успехе onSuccess.
         */}
        <Turnstile
          onSuccess={setToken}
          siteKey={String(process.env.NEXT_PUBLIC_CLOUDFLARE_SITE_KEY)}
          onError={(error) => console.log("error", error)}
          style={{ display: "none" }}
        />

        <BrushSize />
        <PromtArea />
        <RenderButton token={token} />
        <AnimatePhotoPortal token={token} />
        <CustomizeSettingsPortal token={token} />
      </div>
    </div>
  );
};
